import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"
import { Card, CardBody } from "reactstrap"

class ClientBuyerMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
      handleSelectChange = (e) => {
    this.props.history.push(e.target.value);
  };
    render() {
        const { isResponsive } = this.props;
         const { id, clientId } = this.props.match.params;
        const navItems = [
            { id: 'listings', label: 'Listings', link: `/clients/buyer/listings/${id}/${clientId}` },
            { id: 'preferences', label: 'Home Preferences', link: `/clients/buyer/preferences/${id}/${clientId}` },
            { id: 'questions', label: 'Buying Preferences', link: `/clients/buyer/questions/${id}/${clientId}` }
        ];
        return (
            <React.Fragment>
                {isResponsive ? (
                   <Card className="mb-3">
                    <CardBody>
                        <h6>Select Menu</h6>
                         <select
                                className="form-control"
                                onChange={this.handleSelectChange}
                                value={window.location.pathname}  
                            >
                                {navItems.map(item => (
                                <option key={item.id} value={item.link}>
                                    {item.label}
                                </option>
                                ))}
                            </select>
                    </CardBody>
                </Card>  
                ):(
                     <TabNavigation navItems={navItems}   />             
                )}
               
               

              
            </React.Fragment>
        )
    }
}
ClientBuyerMenu.propTypes = {
    match: PropTypes.object,
    isResponsive:PropTypes.object,
    location:PropTypes.object,
    history:PropTypes.object

}
export default withRouter(ClientBuyerMenu)
